var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 10.6834C14.7 12.1654 13.4464 13.3668 11.9 13.3668C10.3536 13.3668 9.09999 12.1654 9.09999 10.6834C9.09999 9.2014 10.3536 8 11.9 8C13.4464 8 14.7 9.2014 14.7 10.6834Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 13.3668C17.6464 13.3668 18.9 12.1654 18.9 10.6834C18.9 9.2014 17.6464 8 16.1 8",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 18.7334C16.8 16.8809 15.233 15.3792 13.3 15.3792H10.5C8.56701 15.3792 7 16.8809 7 18.7334V20.0751H16.8V18.7334Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 20.0751H21V18.7334C21 16.8809 19.433 15.3792 17.5 15.3792",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingIcon);
export default __webpack_public_path__ + "static/media/meeting_icon.26436068a0abc3e5454a1bf12450d145.svg";
export { ForwardRef as ReactComponent };